import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "w-full space-y-4" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "text-2xl font-bold" }, "Browse by categories", -1)
const _hoisted_3 = { class: "grid grid-cols-2 lg:grid-cols-4 gap-4 lg:gap-8" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CategoryCard = _resolveComponent("CategoryCard")!

  return (_openBlock(), _createElementBlock("section", null, [
    _createElementVNode("div", _hoisted_1, [
      _hoisted_2,
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (category) => {
          return (_openBlock(), _createBlock(_component_CategoryCard, {
            key: category.name,
            category: category
          }, null, 8, ["category"]))
        }), 128))
      ])
    ])
  ]))
}